__turbopack_context__.v({
  "Button": "index-module__09DSJq__Button",
  "Close": "index-module__09DSJq__Close",
  "Content": "index-module__09DSJq__Content",
  "Description": "index-module__09DSJq__Description",
  "Text": "index-module__09DSJq__Text",
  "Title": "index-module__09DSJq__Title",
  "Toast": "index-module__09DSJq__Toast",
  "Viewport": "index-module__09DSJq__Viewport",
});
